import $ from 'jquery';

//export const $win = $(window);
//export const $doc = $(document);
//export const $body = $('body');

export const isLocal = (() => {
    return /localhost/.test(document.location.host);
})();

export const isOpdev = (() => {
    return /opdev/.test(document.location.host);
})();

export const isRc = (() => {
    return /rc-/.test(document.location.host);
})();

export const isIE = userAgent => {
    return /msie/i.test(userAgent) || /trident/i.test(userAgent);
};

export const getIEVersion = userAgent => {
    if (isIE(userAgent)) {
        if (/msie (\d+\.\d+);/i.test(userAgent))
            return parseFloat(RegExp.$1, 10);
        if (/trident.*rv:(\d+)\.(\d+)/i.test(userAgent))
            return parseFloat(RegExp.$1, 10);
    }

    return -1;
};

export const existy = obj => {
    return obj != null;
};

export const isDefined = obj => {
    if (obj === null || typeof obj === 'undefined') return false;

    return true;
};

export const isSlickWrapInitialized = $wrap => {
    if ($wrap.length) return $wrap.hasClass('slick-initialized');

    return false;
};

export const isBoolean = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Boolean;
};

export const isNumber = obj => {
    if (!isDefined(obj)) return false;

    return !isNaN(obj) && obj.constructor === Number;
};

export const isInteger = obj => {
    if (!isNumber(obj)) return false;

    // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
    return isFinite(obj) && Math.floor(obj) === obj;
};

export const isString = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === String;
};

export const isArray = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Array;
};

export const isFunction = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Function;
};

export const isObject = obj => {
    if (!isDefined(obj)) return false;

    return obj.constructor === Object;
};

export const not = func => {
    if (!isFunction(func))
        throw new TypeError('func parameter type of not() must be Function.');

    return function () {
        return !func.apply(null, arguments);
    };
};

export const isNotDef = not(isDefined);

export const truthy = obj => {
    return !!obj;
};

export const falsy = obj => {
    return !!!obj;
};

export const hasOwnProp = {}.hasOwnProperty;

export const each = (dataCanLoop, func, context) => {
    if (!(isArray(dataCanLoop) || isString(dataCanLoop))) {
        throw new TypeError(
            'dataCanLoop parameter type of each() must be Array or String.'
        );
    }

    const _context = existy(context) ? context : null;

    for (let i = 0, max = dataCanLoop.length; i < max; i++) {
        func.call(_context, dataCanLoop[i]);
    }
};

export const singleEle = $ele => $ele.length === 1;

export const notSingleEle = not(singleEle);

export const getRandomInt = (minInt, maxInt) => {
    if (!isInteger(minInt) || !isInteger(maxInt)) {
        throw new TypeError(
            'math.getRandomInt() requires Integer Number parameters.'
        );
    }

    return minInt + Math.floor(Math.random() * (maxInt - minInt + 1));
};

export const isMobileEnv = $body =>
    $body.hasClass('mobile') || $body.hasClass('tablet');

export let isMobileResolution = resolution => {
    return resolution === 'phone' || resolution === 'tablet';
};

export let getResolution = (breakpoints = { pc: 960 }, global = window) => {
    let resolution = '';

    if (breakpoints.pc && global.innerWidth >= breakpoints.pc) {
        resolution = 'pc';
    } else {
        resolution = 'tablet';
    }

    return resolution;
};

export const copyTextToClipboardFallback = (
    text,
    doneCallback = null,
    failCallback = null
) => {
    if (isDefined(doneCallback) && !isFunction(doneCallback))
        throw TypeError(
            'doneCallback parameter type of copyTextToClipboardFallback() must be undefined or null or Function.'
        );
    if (isDefined(failCallback) && !isFunction(failCallback))
        throw TypeError(
            'failCallback parameter type of copyTextToClipboardFallback() must be undefined or null or Function.'
        );

    const textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = '-9999px';
    textArea.style.left = '-9999px';
    textArea.style.width = '2em'; // Ensure it has a small width and height. Setting to 1px / 1em doesn't work as this gives a negative w/h on some browsers.
    textArea.style.height = '2em';
    textArea.value = text;
    document.body.appendChild(textArea);

    // textArea.focus();
    // textArea.select();

    textArea.classList.add('shareUrlArea');
    window.getSelection().removeAllRanges();

    let urlField = document.querySelector('.shareUrlArea');
    let range = document.createRange();

    range.selectNode(urlField);
    window.getSelection().addRange(range);

    try {
        const isSuccessCopy = document.execCommand('copy');
        if (isSuccessCopy) {
            if (doneCallback) doneCallback.call(null, text);
            return;
        }

        if (failCallback) failCallback.call(null, new Error(''));
    } catch (error) {
        if (failCallback) failCallback.call(null, error);
    }

    document.body.removeChild(textArea);
};

export const copyTextToClipboard = (
    text,
    doneCallback = null,
    failCallback = null
) => {
    if (isDefined(doneCallback) && !isFunction(doneCallback))
        throw TypeError(
            'doneCallback parameter type of copyTextToClipboard() must be undefined or null or Function.'
        );
    if (isDefined(failCallback) && !isFunction(failCallback))
        throw TypeError(
            'failCallback parameter type of copyTextToClipboard() must be undefined or null or Function.'
        );

    if (!navigator.clipboard) {
        copyTextToClipboardFallback(text, doneCallback, failCallback);
    } else {
        // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
        navigator.clipboard.writeText(text).then(
            () => {
                doneCallback.call(null, text);
            },
            error => {
                failCallback.call(null, error);
            }
        );
    }
};

export const getElementOffset = selector => {
    return $(selector).offset();
};

export const getDecodedUriParams = decodedUri => {
    if (!isString(decodedUri))
        throw new TypeError('getDecodedUriParams() requires String parameter.');

    if (decodedUri.length < 1) return null;
    decodedUri = decodedUri.split('#')[0];

    let tmpArr = decodedUri.split('?');
    if (tmpArr.length < 2) return null;

    const paramStr = tmpArr[1],
        params = paramStr.split('&');

    let obj = {};
    for (
        let param, keyStr = '', valueStr = '', i = 0, max = params.length;
        i < max;
        ++i
    ) {
        param = params[i];

        const eqIndex = param.indexOf('=');
        if (eqIndex >= 0) {
            keyStr = param.substr(0, eqIndex);
            valueStr = param.substr(eqIndex + 1);

            obj[keyStr] = valueStr;
        }
    }

    return obj;
};

export const getReencodedUriParams = uri => {
    let params = {};

    console.log('isDecodedUri(uri) :', isDecodedUri(uri));

    if (isDecodedUri(uri)) {
        // decoded url
        params = getDecodedUriParams(uri);
    } else {
        // encoded url
        const decodedUrl = window.decodeURIComponent(uri);
        params = getDecodedUriParams(decodedUrl);
    }

    // encode parameter values
    for (let i in params) params[i] = window.encodeURIComponent(params[i]);

    return params;
};

export const getUriCombinedParams = (uri, parameters) => {
    if (!isString(uri))
        throw new TypeError(
            'uri parameter type of getUriCombinedParams() must be String.'
        );

    if (!isObject(parameters))
        throw new TypeError(
            'parameters parameter type of getUriCombinedParams() must be Object.'
        );

    if (!uri) return '';
    if (!parameters) return uri;

    let str = '';
    for (let key in parameters) {
        str += '&' + key + '=' + String(parameters[key]);
    }

    if (str === '') return uri;

    let tmpArr = uri.split('#'),
        hashStr =
            isDefined(tmpArr[1]) && tmpArr[1].length ? '#' + tmpArr[1] : '';

    uri = tmpArr[0];
    uri =
        (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) +
        hashStr;

    return uri;
};

export const getUriParams = uri => {
    if (!isString(uri))
        throw new TypeError('getUriParams() requires String parameter.');

    if (uri.length < 1) return null;
    uri = uri.split('#')[0];

    let tmpArr = uri.split('?');
    if (tmpArr.length < 2) return null;

    const paramStr = tmpArr[1],
        params = paramStr.split('&');

    let obj = {};
    for (let keyValueArr, i = 0, max = params.length; i < max; ++i) {
        keyValueArr = params[i].split('=');
        if (keyValueArr.length <= 1) return null;

        obj[keyValueArr[0]] = keyValueArr[1];
    }

    return obj;
};

export const isDecodedUri = uri => {
    return window.decodeURIComponent(uri) === uri;
};

export const setCookie = (name, value, expiredays, path, domain) => {
    const date = new Date();
    date.setDate(date.getDate() + expiredays);

    const pathStr = '; path=' + (path ? path : '/'),
        domainStr = '; domain=' + (domain ? domain : '.plaync.com'),
        expiresStr = '; expires=' + date.toGMTString();

    document.cookie =
        name + '=' + escape(value) + pathStr + domainStr + expiresStr;
};
